import Component from '../vendor/Component'

export default class WishlistTrigger extends Component {
  constructor(elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this.swatReady = false
    this.wishlistId = ''
    this.buttonEl = this._elem.querySelector('[data-wishlist-trigger-el="button"]')
  }

  async mount() {
    if (!this.swatReady) {
      await this.checkSwatReady()
    }

    this.fetchLists()
    this.setupListeners()
  }

  setupListeners() {
    this.buttonEl.addEventListener('click', this.handleTriggerClick.bind(this))
  }

  handleTriggerClick(event) {
    this.buttonEl.dataset.loading = 'true'
    const productIsAdded = event.currentTarget.getAttribute('data-added', 'false') === 'true'
    const { variantId, productId, productUrl } = this.buttonEl.dataset

    if (productIsAdded) {
      this.removeProduct(
        this.wishlistId,
        variantId,
        productId,
        productUrl
      )
    } else {
      this.addProduct(
        this.wishlistId,
        variantId,
        productId,
        productUrl
      )
    }
  }

  async fetchLists() {
    const onSuccess = function(lists) {
      this.wishlistId = lists[0].lid
      this.setButtonState(lists[0].listcontents)
      this._elem.setAttribute('aria-hidden', 'false')
    }

    const onError = function(error) {
      console.error("Error while fetching Swym wishlists", error);
    }

    window._swat.fetchLists({
      callbackFn: onSuccess.bind(this),
      errorFn: onError
    });
  }

  async addProduct (wishlistId, variantId, productId, productUrl) {
    const product = {
      epi: variantId,
      empi: productId,
      du: productUrl,
    }

    const onSuccess = function (item) {
      this.buttonEl.dataset.loading = 'false'
      this.buttonEl.dataset.added = 'true'
      console.log('Swym addProduct() - Success', item)
    }

    const onError = function (errorMessage) {
      console.error('Swym addProduct() - Error', errorMessage)
    }

    window._swat.addToList(
      wishlistId,
      product,
      onSuccess.bind(this),
      onError,
    )
  }

  async removeProduct (wishlistId, variantId, productId, productUrl) {
    const product = {
      epi: variantId,
      empi: productId,
      du: productUrl,
    }

    const onSuccess = function (item) {
      this.buttonEl.dataset.loading = 'false'
      this.buttonEl.dataset.added = 'false'
      console.log('Swym removeProduct() - Success', item)
    }

    const onError = function (error) {
      console.error('Swym removeProduct() - Error', error)
    }

    window._swat.deleteFromList(
      wishlistId,
      product,
      onSuccess.bind(this),
      onError,
    )
  }

  setButtonState (listContents) {
    const productId = parseInt(this.buttonEl.dataset.productId)
    const exists = listContents.some(obj => obj.empi === productId);

    this.buttonEl.dataset.added = exists
  }

  checkSwatReady () {
    return new Promise((resolve) => {
      const intervalId = setInterval(() => {
        if (!window._swat) return

        clearInterval(intervalId)

        this.swatReady = true

        resolve(true)
      }, 200)
    })
  }
}
